
const deleteClassName = 'delete-product-button_ki85s', // 删除图标
    addClassName = 'add-product-button_ki85s', // 添加图标
    pingClassName = "product_image_wrapper", // 产品图片
    pinThumbsSliderImageClassName = "slide-image";


const popupContainer = document.getElementById('product-popup_kd585x')
    popupSwiperWrapper = document.getElementById('popup-swiper-wrapper'),
    popupThumbsSliderWrapper = document.getElementById('popup-thumbsSlider-wrapper'),
    popupAddBuuton = document.getElementById('popup-buuton_kd585'),
    popupDescribe = document.getElementById('popup-des_kd585'),
    popupButtonClassName = "popup-buuton_kd585";


let showDeleteButton = false; // 在pin页面隐藏包的删除按钮


/***
 *  selectedElement 选中产品的 swiper 容器
 *  productData 产品数据
 *  selectedProductData 选中的产品数据
 *  options
 *     type  add 添加购物车， add_bag 添加包 , add_pin 添加配件
 * 
*/

function initCustom (selectedElement, productData, selectedProductData, options) {
    let cartProductData = getItem('cartProductData'); // 将选中的添加到购物车，但是从购物车返回啦，需要重新渲染
    let currentAriaLabel = null;

    if (options.type == "add") {
        selectedProductData = cartProductData.length > 0 ? cartProductData : selectedProductData;
        
        clearSelectedElement(selectedElement);
        renderSellerSelectedProducts(selectedProductData, selectedElement);
    }


    // 在自定义pin的页面返回到 bag 页面时渲染选中的包
    if ( options.type === 'add_bag') {
        removeItem('enablePrompt');
        removeItem('activeIndex');
        selectedProductData = getItem('sellerCustomBag');
        if (selectedProductData.length > 0) {
            renderSellerSelectedProducts(selectedProductData, selectedElement);
        }
    }
    
    // 在自定义pin是启用
    if (options.type === 'add_pin') {
        showDeleteButton = true
        let bagData = getItem('sellerCustomBag');

        // 选中pin 页面的 swiper 元素
        const productSwiper = document.getElementById('product-swiper-wrapper__52sex'),
        productThumbsSlider = document.getElementById('product-thumbsSlider-wrapper_52sex'),
        productTitle = document.getElementById('buyer-product-title_52sex'),
        productPrice = document.getElementById('buyer-product-price_52sex');

        // swiper 和 选中产品的 父元素
        let elementDOM = {
            selectedElement,
            productSwiper,
            productThumbsSlider
        }

        // swiper 下产品信息元素
        let productElement = {
            productTitle,
            productPrice
        }

       renderBag(elementDOM, bagData, cartProductData);
       renderProductInfo(productElement, bagData[0]);
       selectedProductData = cartProductData.length > 0 ? cartProductData : bagData;


       initSwiper(bagData, productElement);
    }

    // 自定义系列添加代理事件处理函数
    $('#proxy-container').click(function (event) {
        let __target = event.target;
        let ProductId = Number(__target.dataset.id),
            CurrentProduct = findProduct(productData, ProductId);


        // 处理添加
        if (__target.className === addClassName) {
            addProduct(CurrentProduct);
            return;
        }

        // 处理打开弹框
        if (__target.className.indexOf(pingClassName) != -1) {
            openPopup(CurrentProduct);
            return;
        }
    });




    // 选中列表点击处理事件
    $(selectedElement).click(function (event) {
        event.preventDefault();
        let __target = event.target;
        let ProductId = Number(__target.dataset.id);
        let currentSlideItem = $(__target).parents('.swiper-slide');
        currentAriaLabel = currentSlideItem.attr('aria-label');

        if (__target.className === deleteClassName) {
            deleteProduct(ProductId);
        }

        // 处理打开弹框
        if (__target.className === pingClassName) {
            let CurrentProduct = findProduct(selectedProductData, ProductId);
            openPopup(CurrentProduct);
        }
    });




    // 查找对应的产品
    function findProduct(arr, id) {
        return arr.find(function (x) { return Number(x.id) === id})
    }


    // 添加产品到选中列表
    function addProduct(CurrentProduct) {
        let product = createSelectedProductData(CurrentProduct);
        selectedProductData.push(product);
        createProductElement(product, selectedElement);
    }

    // 创建选中产品的数据 --- 函数位置（add-selected-product.liquid）





    // 删除选中的产品
    function deleteProduct(id) {
        // let newSelectedProduct = selectedProductData.find(item => conditions.some(condition => condition(item)))
        // let newSelectedProduct = selectedProductData.filter(function (x) { return x.id != id});

        let deleteFilterProduct = selectedProductData.filter(function (x) { return x.id === id });
        deleteFilterProduct.shift();

        let otherFilterProduct = selectedProductData.filter(function (x) { return x.id != id });

        selectedProductData = otherFilterProduct.concat(deleteFilterProduct)

        deleteProductElement(id);
        console.log('Product deleted ....');
    }

    // 删除选中产品对应DOM  
    function deleteProductElement(id) {
        let productArr = []
        $('.selected-product-item').each(function (index, item) {
            let ProductId = Number(item.dataset.id);
            if (ProductId === id) {
                productArr.push(item)
                //
            }
        });

        $(productArr).each(function (index, deleteItem) {
            let deleteItemAriaLabel = $(deleteItem).attr('aria-label');
            if (currentAriaLabel === deleteItemAriaLabel) {
                $(deleteItem).remove();
            }
        });
    }





    // 打开弹框 并且修改数据
    function openPopup(product) {
        let Image = product.images;
        setPopupSwiperData(popupSwiperWrapper, Image);
        setPopupSwiperData(popupThumbsSliderWrapper, Image);
        $(popupAddBuuton).attr("data-id", product.id);
        $(popupDescribe).html(product.content);
        $('.product-popup_kd585x').addClass('popup-active');
    }


    // 点击产品弹框处理事件
    $(popupContainer).click(function (event) {
        let __target = event.target,
            ProductId = Number(__target.dataset.id),
            CurrentProduct = findProduct(productData, ProductId);

        if (__target.id === popupButtonClassName) {
            addProduct(CurrentProduct);
            closePopup();
            return;
        }
    });

    $('.product-popup_kd585x').click(function (event) {
        let __target = event.target
        if (__target.className === 'popup-wrapper_kd585x') {
            closePopup();
        }
    });
    $('.popup-close_kd585x').click(function () {
        closePopup();
    });

    // 关闭产品弹框
    function closePopup() {
        $('.product-popup_kd585x').removeClass('popup-active');
        popupSwiperWrapper.innerHTML = '';
        popupThumbsSliderWrapper.innerHTML = '';
        $(popupAddBuuton).removeAttr('data-id')
        $(popupDescribe).html("");
    }





    // 点击选中产品模块的第一个按钮的处理函数
    $('#add-cart').click(function (event) {
        event.preventDefault();

        switch (options.type) {
            case "add": 
                addItems(selectedProductData, true);
                break;
            case "add_bag":
                addBag(selectedProductData)
                break;
            case "add_pin":
                setAddPinButton(selectedProductData);
                return;
                // addPin(selectedProductData);
                break;
            default:
                addItems(selectedProductData, true);
                break;
        }
    });



    // 点击翻页时处理事件
    $('.pagination__item').click(function (event) {
        event.preventDefault();
        setItem('cartProductData', selectedProductData);
        let dataHref = $(this).data('href');
        window.location.href = dataHref;
    });

    $('.facets__heading_item').click(function () {
        setItem('cartProductData', selectedProductData);
    });

    // 点击swiper缩略图处理事件
    $('#product-thumbsSlider-wrapper_52sex').click(function (event) {
       if (event.target.className === pinThumbsSliderImageClassName) {
        setItem('cartProductData', selectedProductData);
       }
    });
}




// 卖家自定义bag pin页面 --- save是否需要将数据保存在本地
function addItems (data, save = false) {
    if (data.length > 0) {
        let items = data.map(function (x) {
            return {
                id: x.variantId,
                quantity: 1,
            }
        })
        addCart(items.reverse())
        .then(function () {
            if (save) {
                setItem('cartProductData',data);
            }
            window.location.href = Shopify.cart_url;
        })
    } else {
        console.log('No products added !!!');
    }
}


// 删除购物车的产品
function deleteCart() {
    return new Promise(function (resolve, reject) {
        $.ajax({
            type: "GET", 
            url: window.Shopify.routes.root + 'cart/clear', 
            dataType: "json",
            success: function (response) { 
                resolve(response)
            },
            error: function (xhr, status, error) {
                reject(xhr)
            }
        });
    });
};



// 在自定义 bag 页面时触发
function addBag (data) {
    if (true) {
        setItem('sellerCustomBag', data);
        let collection_url = data[0].collection_url
        window.location.href = collection_url;
    } else {
        console.log('No products added !!!');
    }
}

// 在自定义pin页面时触发
function addPin (data) {
    let isNext = getItem('pinNext', "true");
    if (isNext) {
        setItem('showCartBanner', "true");
        addItems(data, true);
    }
}

// 在自定义pin页面点击按钮时触发
function setAddPinButton (data) {
    let enablePrompt = getItem('enablePrompt', 'false');
    if (enablePrompt) {
        $('#cart-button-prompt').addClass('tig-active')
        setItem('enablePrompt', false);
    } else {
        addPin(data);
    }
}



















// 渲染选中的产品
function renderSellerSelectedProducts (array, element) {
    for (item of array) {
        createProductElement(item, element)
    }
}


// 创建选中的产品DOM
function createProductElement(product, parentElement) {
    let selectedDiv = document.createElement("div");
    selectedDiv.className = 'swiper-slide recommend-product-slide selected-product-item';
    $(selectedDiv).attr('data-id', product.id)
    selectedDiv.innerHTML = createElementDom(product);

    parentElement.appendChild(selectedDiv);
}

// 创建添加选中产品的内容
function createElementDom(product) {
    // style="display: ${product.delete === false && showDeleteButton  ? 'none' : 'block'};" 
    return `
            <div class="product-item-lvl">
                <a href="#"
                    class="product-link">
                    <div class="product_image_wrapper" data-id="${product.id}">
                        <img src="${product.image}" 
                            alt=""
                            class="product__preview_image"
                            srcset="${product.image} 260w, ${product.image} 1118w"
                            sizes="(min-width: 300px) 100vw, (min-width: 992px) 50vw, 300px">
                    </div>

                    <h5 class="default-space product-title-lvl">${product.title}</h5>

                    <p class="default-space product-price-lvl">
                        ${product.price}
                    </p>
                </a>

                <button class="delete-product-button_ki85s" data-id="${product.id}" >
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                        <path d="M10.5187 7.22812C10.9381 7.22812 11.2781 7.56811 11.2781 7.9875V12.2906C11.2781 12.71 10.9381 13.05 10.5187 13.05C10.0993 13.05 9.75933 12.71 9.75933 12.2906V7.9875C9.75933 7.56811 10.0993 7.22812 10.5187 7.22812Z" fill="#F26E39"/>
                        <path d="M8.24058 7.9875C8.24058 7.56811 7.90059 7.22812 7.4812 7.22812C7.06181 7.22812 6.72183 7.56811 6.72183 7.9875V12.2906C6.72183 12.71 7.06181 13.05 7.4812 13.05C7.90059 13.05 8.24058 12.71 8.24058 12.2906V7.9875Z" fill="#F26E39"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.21551 4.19062C6.21551 2.65286 7.46212 1.40625 8.99989 1.40625C10.5377 1.40625 11.7843 2.65286 11.7843 4.19062H14.8218C15.2412 4.19062 15.5812 4.53061 15.5812 4.95C15.5812 5.36939 15.2412 5.70937 14.8218 5.70937H14.0624L14.0622 11.2276C14.0622 12.9287 14.0622 13.7793 13.7311 14.429C13.4399 15.0006 12.9752 15.4652 12.4037 15.7564C11.7539 16.0875 10.9033 16.0875 9.2022 16.0875H8.79744C7.09623 16.0875 6.24563 16.0875 5.59586 15.7564C5.0243 15.4652 4.55962 15.0005 4.2684 14.429C3.93734 13.7792 3.93735 12.9286 3.93739 11.2274L3.9375 5.70937H3.17808C2.75868 5.70937 2.4187 5.36939 2.4187 4.95C2.4187 4.53061 2.75868 4.19062 3.17808 4.19062H6.21551ZM7.73426 4.19062C7.73426 3.49164 8.3009 2.925 8.99989 2.925C9.69888 2.925 10.2655 3.49164 10.2655 4.19062H7.73426ZM5.45627 5.70937H12.5436L12.5435 11.2276C12.5435 12.1032 12.5423 12.6686 12.5071 13.0989C12.4734 13.5115 12.4162 13.6644 12.3779 13.7395C12.2323 14.0253 11.9999 14.2576 11.7142 14.4032C11.6391 14.4415 11.4861 14.4987 11.0735 14.5324C10.6432 14.5676 10.0778 14.5687 9.2022 14.5687H8.79744C7.92177 14.5687 7.35637 14.5676 6.92603 14.5324C6.51343 14.4987 6.36046 14.4415 6.28537 14.4032C5.99959 14.2576 5.76725 14.0253 5.62164 13.7395C5.58338 13.6644 5.52616 13.5114 5.49246 13.0988C5.45731 12.6685 5.45614 12.1031 5.45616 11.2274L5.45627 5.70937Z" fill="#F26E39"/>
                    </svg>
                </button>
            </div>
        `;
}




// 修改产品弹框swiper的内容
function setPopupSwiperData(element, imageList) {
    $(imageList).each(function (index, link) {
        let slide = createSlideElement(link);
        element.appendChild(slide);
    });
 };


// 在用户自定义pin 页面修改包的数据
function setProductSwiperData (element, array) {
    $(array).each(function (index, item) {
        let slide = createSlideElement(item.image);
        $(slide).attr('data-collectionURL', item.collection_url)
        element.appendChild(slide);
    });
}


// 创建slide元素 并添加图片
function createSlideElement(url) {
    let slideDiv = document.createElement("div"),
        slideIma = new Image();

    slideDiv.className = "swiper-slide";
    slideIma.src = url;
    slideIma.className = 'slide-image';
    slideDiv.appendChild(slideIma);

    return slideDiv;
}










// 商家自定义页面 --- 切换分页的时候
function clearSelectedElement (element) {
    element.innerHTML = '';
}




// pin页面渲染 swiper 和 选中 bag 产品
function renderBag (elementDOM, array, cartArray) {
    if (array.length > 1) {
        let enablePrompt = getItem('enablePrompt', 'true');
        if (enablePrompt) {
            setItem('enablePrompt', true); // 显示第三步按钮的提示
        }
    }

    setProductSwiperData(elementDOM.productSwiper, array);
    setProductSwiperData(elementDOM.productThumbsSlider, array);


    let selectedArray = cartArray.length > 0 ? cartArray : array;
    $(selectedArray).each(function (index, item) {
        createProductElement(item, elementDOM.selectedElement)
    });
}

// pin页面渲染 swiper 和 选中 bag 产品信息
function renderProductInfo (element, data) {
    $(element.productTitle).text(data.title);
    $(element.productPrice).text(data.price);
}







// 初始 pin 页面的 bag swiper
function initSwiper (bagData, element) {
    let currentBag = getItem('currentBag', '{}'); // 点击缩略图切换 bag 产品
    let activeIndex = getItem('activeIndex', '0'); // bag的活跃 index
    let enableJump = false; // 是否需要跳转页面

    let thumbsSwiper = new Swiper("#product-thumbsSlider", {
        spaceBetween: 10,
        slidesPerView: 3,
        freeMode: true,
        watchSlidesProgress: true,
        navigation: {
            nextEl: ".product-next",
            prevEl: ".product-prev",
        },
        on: {
            click: function () {
                enableJump = true;
            }
        }
    });


    let productSwiperElement = new Swiper("#product-swiper", {
        spaceBetween: 10,
        effect: 'fade',
        thumbs: {
            swiper: thumbsSwiper,
        },
        on:{
            slideChange: function() {
                let data = bagData[productSwiperElement.activeIndex];
                setItem('currentBag', data);
                setItem('activeIndex', productSwiperElement.activeIndex);
                setItem('enablePrompt', false);
                
                setTimeout(function () {
                    if (enableJump) {
                        window.location.href = data.collection_url;
                    }
                }, 100);
                
            },
        },
    });


    // 是否在自定义pin 页面中点击 产品缩略图
    if (currentBag.id != {} && currentBag != null) {
        renderProductInfo(element, currentBag);
        thumbsSwiper.slideTo(activeIndex);
        productSwiperElement.slideTo(activeIndex);
    } 

}


function mySetArrList (arr1, arr2) {
    let array = arr1.concat(arr2); 
    let newArray = []; 
    for(item1 of array){  
        let flag = true;  

        for(item2 of newArray){  
            if(item1.id==item2.id){ 
                flag = false;
            }
        }

        if(flag){
            newArray.push(item1);
        }
    }
    return newArray
}



function getItem(key, defaultValue = "[]") {
    return JSON.parse(sessionStorage.getItem(key) || defaultValue)
}

function setItem(key, data) {
    return sessionStorage.setItem(key, JSON.stringify(data));
}


function removeItem(key) {
    sessionStorage.removeItem(key);
}